<template>
  <div class="nav">
    <section>
      <div>
        <router-link v-if="!isMediumScreen" to="/">
          <h3>Mealist</h3>
        </router-link>
        <router-link :to="{ name: 'adminIngredients' }" target="_blank"
          ><i v-if="isAdmin">Admin</i></router-link
        >
      </div>
      <ul class="menu-container">
        <li v-if="!isMediumScreen && userProfile.workspaces.length > 1">
          <Select
            class="select-workspace"
            title="Espace"
            :key="workspacesOptions.length"
            :options="workspacesOptions"
            :selected-id="selectedWorkspaceId"
            @change="onWorkspaceChange"
          />
        </li>
        <li>
          <router-link to="/">
            <Icon
              icon="fas fa-calendar-week"
              text="Ma semaine"
              :showText="!isMediumScreen"
            />
          </router-link>
        </li>
        <li>
          <router-link to="/meals">
            <Icon
              icon="fas fa-hamburger"
              text="Mes repas"
              :showText="!isMediumScreen"
            />
          </router-link>
        </li>
        <li>
          <router-link to="/shopping">
            <Icon
              icon="fas fa-shopping-cart"
              text="Ma Liste de courses"
              :showText="!isMediumScreen"
            />
          </router-link>
        </li>
        <!-- Dropdown (Bulma) -->
        <li>
          <div
            class="dropdown is-right"
            :class="{ 'is-active': isDropdownActive, 'is-up': isLittleScreen }"
          >
            <div
              class="dropdown-trigger"
              @click="isDropdownActive = !isDropdownActive"
              v-on-clickaway="onClickAway"
            >
              <a aria-haspopup="true" aria-controls="{ 'dropdown-menu'}">
                <Icon
                  class="dropdown-icon"
                  :class="{ rotate: isDropdownActive }"
                  icon="fas fa-caret-down"
                />
              </a>
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
              <div class="dropdown-content">
                <div>
                  <router-link to="/myProfile">
                    <Icon icon="far fa-user-circle" text="Mon compte" />
                  </router-link>
                </div>
                <div>
                  <a @click="logout()">
                    <Icon icon="fas fa-sign-out-alt" text="Déconnexion" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import _ from 'lodash';
import { mixin as clickaway } from 'vue-clickaway';

import Select from '../Form/Select.vue';

export default {
  mixins: [clickaway],
  components: {
    Select,
  },
  data() {
    return {
      selectedWorkspaceId: null,
      isDropdownActive: false,
    };
  },
  mounted() {
    // Check if we already have this data (otherwise we get it in watch)
    this.selectedWorkspaceId = _.get(this.currentWorkspace, 'id', null);
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
    onWorkspaceChange(workspaceId) {
      // Si on change uniquement
      if (workspaceId !== this.currentWorkspace.id) {
        this.$store.dispatch('setCurrentWorkspace', workspaceId);
      }
    },

    /**
     * Quand on clique hors du btn dropdown
     */
    onClickAway() {
      this.isDropdownActive = false;
    },
  },
  computed: {
    workspacesOptions() {
      return this.userProfile.workspaces.map((w) => {
        return {
          value: w.id,
          text: w.name,
          color: w.color,
        };
      });
    },

    /**
     * Mon compte - Prénom Nom
     */
    tooltipMyProfile() {
      return `${this.$t('nav.my-profile')} - ${this.userProfile.name}`;
    },
  },
  watch: {
    currentWorkspace(newCurrWorkspace) {
      this.selectedWorkspaceId = newCurrWorkspace.id;
    },
  },
};
</script>

<style lang="scss" scoped src="./Nav.scss"></style>
